import { iSubRoute } from "../../../definitions/interfaces"

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export function getArtistRoutes({ urlPrefix = "", type = "edit" }) {
  return routes.map((r) => {
    return { ...r, route: urlPrefix + r.route }
  })
}

const routes: iSubRoute[] = [
  {
    title: "Overview",
    route: "",
  },
  {
    title: "Uploads",
    route: "/uploads",
  },
  // {
  //   title: "Access",
  //   route: "/access",
  // },
]
